var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionTooltip(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 25C16.3137 25 19.3137 23.6568 21.4853 21.4853C23.6568 19.3137 25 16.3137 25 13C25 9.68632 23.6568 6.68632 21.4853 4.51472C19.3137 2.34315 16.3137 1 13 1C9.68632 1 6.68632 2.34315 4.51472 4.51472C2.34315 6.68632 1 9.68632 1 13C1 16.3137 2.34315 19.3137 4.51472 21.4853C6.68632 23.6568 9.68632 25 13 25Z",
    fill: "#E65088",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0004 15.7758V13.3758C14.9886 13.3758 16.6004 11.764 16.6004 9.77578C16.6004 7.78756 14.9886 6.17578 13.0004 6.17578C11.0122 6.17578 9.40039 7.78756 9.40039 9.77578",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 21.1758C13.8284 21.1758 14.5 20.5042 14.5 19.6758C14.5 18.8474 13.8284 18.1758 13 18.1758C12.1716 18.1758 11.5 18.8474 11.5 19.6758C11.5 20.5042 12.1716 21.1758 13 21.1758Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionTooltip);
export default __webpack_public_path__ + "static/media/questionTooltip.fe8a27d7f69ad2a0a2b983501d4bb90b.svg";
export { ForwardRef as ReactComponent };